import { Checkbox, ListItemText } from "@mui/material";
import { ConditionTagBaseMenuItem } from "./ConditionTagBaseMenuItem";
import { KeyboardEvent } from "react";

export type CheckboxMenuItemProps = {
  label: string;
  value: string;
  isChecked: boolean;
  onClick?: (value: string) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLLIElement>, label: string) => void;
};

export const ConditionTagCheckboxMenuItem = ({
  label,
  value,
  isChecked,
  onClick,
  onKeyDown,
}: CheckboxMenuItemProps) => {
  return (
    <ConditionTagBaseMenuItem
      label={label}
      value={value}
      onClick={onClick}
      onKeyDown={onKeyDown}
      sx={{
        "&.MuiMenuItem-root": {
          p: 0.5,
          my: 1,
        },
      }}
    >
      <Checkbox
        checked={isChecked}
        disableRipple
        sx={{
          "&.MuiCheckbox-root": {
            p: 0,
            px: 0.5,
          },
        }}
      />
      <ListItemText primary={label} sx={{ ml: 1 }} />
    </ConditionTagBaseMenuItem>
  );
};
